import { v4 as uuid } from 'uuid';
import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import HomeLoanCompareProductSplit from './HomeLoanCompareProductSplit';
import HomeLoanCompareProductRepayment from './HomeLoanCompareProductRepayment';
import HomeLoanCompareProductCost from './HomeLoanCompareProductCost';
import HomeLoanCompareProductCommissionsPayable from './HomeLoanCompareProductCommissionsPayable';
import type { IHomeLoanCompareProduct } from './HomeLoanCompareProduct.interface';

export default class HomeLoanCompareProduct implements IHomeLoanCompareProduct {
  id: string;
  idLender: string;
  productSplits: Array<HomeLoanCompareProductSplit>;
  repayments: HomeLoanCompareProductRepayment;
  costs: HomeLoanCompareProductCost;
  commissionsPayable: HomeLoanCompareProductCommissionsPayable;
  shortTotalCosts: number;
  comparativeSaving: number;
  bestSaving: boolean;
  isPreferred: boolean;

  static build = (data: IHomeLoanCompareProduct) => new HomeLoanCompareProduct(data);
  static blank = () => new HomeLoanCompareProduct();

  /**
   * Constructor
   * @param {IHomeLoanCompareProduct} data
   */
  constructor(data?: IHomeLoanCompareProduct) {
    this.id = toUUID(data?.id) || uuid();
    this.idLender = data?.idLender || '';
    this.productSplits = map(
      compact(data?.productSplits),
      (obj) => new HomeLoanCompareProductSplit(obj)
    );
    this.repayments = new HomeLoanCompareProductRepayment(data?.repayments);
    this.costs = new HomeLoanCompareProductCost(data?.costs);
    this.commissionsPayable = new HomeLoanCompareProductCommissionsPayable(
      data?.commissionsPayable
    );
    this.shortTotalCosts = parseFloat(data?.shortTotalCosts || 0);
    this.comparativeSaving = parseFloat(data?.comparativeSaving || 0);
    this.bestSaving = data?.bestSaving === true;
    this.isPreferred = data?.isPreferred === true;
  }
}
